/**
 * Returns only the selected ids for attachments that are still in the state
 * @param state selectedIds
 * @param action add attachments action
 * @returns selected ids for attachments that are stil in the state
 */
export function addAttachmentSelectedIdsReducer(state, action) {
    // the below logic is for an edge-case where the user has multiple tabs open and while they
    // have one tab open, they select attachments in the share estimate pdf modal, the close the attachments panel
    // in the second tab they then delete attachments that were selected in the first tab
    // when they open the panel again, we fetch existing attachments and only need to show selected ids for existing attachments
    const retainedSelectedIds = new Set();
    if (state.size > 0) {
        // short-circuit since we only need to do the check if there are existing selected ids
        action.payload.attachments.forEach(attachment => {
            if (state.has(attachment.id)) {
                retainedSelectedIds.add(attachment.id);
            }
        });
    }
    return retainedSelectedIds;
}
//# sourceMappingURL=addAttachmentSelectedIdsReducer.js.map